export const diagnosticLabels = {
	HU: {
		title: 'Better Auth fejlesztői teszt',
		note: 'Ez a munkamenet csak diagnosztikai célú. A bejelentkezés az alkalmazás munkamenetét használja.',
		email: 'E-mail',
		language: 'Nyelv',
		localeName: 'Magyar',
		send: 'Kód kérése',
		code: 'Hatjegyű kód',
		verify: 'Kód ellenőrzése',
		back: 'Másik e-mail',
		resend: 'Új kód kérése',
		generic: 'Ha a fiók jogosult, elküldtük a kódot. A kód 5 percig érvényes.',
		success: 'Diagnosztikai munkamenet aktív',
		logout: 'Diagnosztikai kijelentkezés',
		expired: 'A munkamenet lejárt vagy kijelentkeztél.',
		error: 'Érvénytelen vagy lejárt kód. Próbáld újra.',
		retry: 'A küldés nem sikerült. Próbáld újra.',
		limit: 'Túl sok kérés. Várj egy percet.',
		invalid: 'Ellenőrizd az e-mail-címet és a hatjegyű kódot.',
		offline: 'Nincs hálózati kapcsolat. Próbáld újra, ha helyreállt.',
		expires: 'Lejárat',
	},
	EN: {
		title: 'Better Auth developer test',
		note: 'This session is diagnostic only. Sign-in uses the application session.',
		email: 'Email',
		language: 'Language',
		localeName: 'English',
		send: 'Request code',
		code: 'Six-digit code',
		verify: 'Verify code',
		back: 'Change email',
		resend: 'Resend code',
		generic: 'If the account is eligible, a code has been sent. It expires in 5 minutes.',
		success: 'Diagnostic session active',
		logout: 'Diagnostic sign out',
		expired: 'Session expired or signed out.',
		error: 'Invalid or expired code. Try again.',
		retry: 'Delivery failed. Please retry.',
		limit: 'Too many requests. Wait one minute.',
		invalid: 'Check the email and six-digit code.',
		offline: 'You are offline. Retry when connected.',
		expires: 'Expires',
	},
}
